'use strict';

angular.module('userRequestEditControllers')

.controller('DisplayEventsController', ['$scope', 'events', function ($scope, events) {

    $scope.events = events;

}]);